var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserPlus = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 5.83333V8.33333M16.6666 8.33333V10.8333M16.6666 8.33333H14.1666M16.6666 8.33333H19.1666M10.8333 5C10.8333 6.84095 9.34091 8.33333 7.49996 8.33333C5.65901 8.33333 4.16663 6.84095 4.16663 5C4.16663 3.15905 5.65901 1.66667 7.49996 1.66667C9.34091 1.66667 10.8333 3.15905 10.8333 5ZM4.3333 18.3333H10.6666C12.1394 18.3333 13.3333 17.1394 13.3333 15.6667C13.3333 13.4575 11.5424 11.6667 9.33329 11.6667H5.66663C3.45749 11.6667 1.66663 13.4575 1.66663 15.6667C1.66663 17.1394 2.86054 18.3333 4.3333 18.3333Z",
    stroke: "#23252F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserPlus);
export default ForwardRef;